import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="136"
      height="48"
      viewBox="0 0 352 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5308 128 16.1458 128 18.7608 128C123.587 128 228.413 128 333.239 128C335.854 128 338.469 128 341.084 128C342.589 128 344.094 128 345.598 128C346.103 128.001 346.59 127.944 347.08 127.827C347.316 127.77 347.548 127.7 347.776 127.618C348.696 127.284 349.448 126.806 350.139 126.11C350.236 126.013 350.329 125.912 350.419 125.809C350.534 125.678 350.643 125.542 350.746 125.402C350.753 125.392 350.761 125.382 350.768 125.372C351.015 125.033 351.225 124.679 351.401 124.299C351.409 124.283 351.416 124.266 351.424 124.249C351.432 124.232 351.439 124.215 351.447 124.198C351.455 124.182 351.462 124.164 351.469 124.147C351.491 124.096 351.513 124.044 351.534 123.993C351.538 123.981 351.544 123.968 351.549 123.956C351.645 123.712 351.725 123.465 351.792 123.212C351.794 123.203 351.796 123.195 351.799 123.186C351.932 122.662 351.998 122.141 351.998 121.6C351.998 117.333 351.998 113.067 351.998 108.799C351.998 74.6665 351.998 40.5336 351.998 6.40019C351.998 2.86566 349.133 0 345.598 0C344.094 0 342.589 0 341.084 0C339.869 0 338.654 0 337.439 0C337.405 0 337.372 0 337.337 0C337.287 0 337.238 0 337.188 0C335.871 0 334.554 0 333.238 0C228.412 0 123.585 0 18.7603 0C17.4435 0 16.1272 0 14.8109 0C14.7613 0 14.711 0 14.6613 0C14.6275 0 14.5936 0 14.5592 0C13.3445 0 12.1292 0 10.9146 0C9.40975 0 7.90499 0 6.40019 0C2.86566 0 0 2.86566 0 6.40019C0 40.5336 0 74.6665 0 108.799C0 113.067 0 117.333 0 121.6C0 125.134 2.86566 128 6.40019 128C7.90612 128 9.41092 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.533 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.8663 127.999 6.40196 127.999C7.90676 127.999 9.41159 127.999 10.9164 127.999C13.5314 127.999 16.1465 127.999 18.761 127.999C48.9213 127.999 191.08 127.999 221.24 127.999C223.856 127.999 338.47 127.999 341.085 127.999C342.59 127.999 344.095 127.999 345.6 127.999C346.104 128.001 346.591 127.943 347.081 127.826C347.318 127.77 347.549 127.7 347.777 127.618C348.697 127.284 349.45 126.805 350.139 126.11C350.236 126.013 350.33 125.912 350.42 125.809C350.849 125.318 351.185 124.793 351.448 124.198C351.456 124.182 351.463 124.164 351.471 124.147C351.602 123.842 351.709 123.532 351.793 123.211C351.795 123.202 351.797 123.194 351.799 123.185C351.934 122.661 351.999 122.14 351.999 121.599C351.999 117.332 351.999 113.066 351.999 108.799C351.999 108.666 351.999 108.532 351.999 108.399H0.0012207V108.4Z"
        fill="url(#paint0_linear_6150_22791)"
      />
      <path
        opacity="0.2"
        d="M19.6007 0C19.3207 0 19.0408 0 18.7608 0C17.4445 0 16.1277 0 14.8114 0C14.7618 0 14.7115 0 14.6618 0C14.628 0 14.5941 0 14.5602 0C13.345 0 12.1298 0 10.9151 0C9.41031 0 7.90548 0 6.40068 0C2.86559 0 0.000488281 2.86566 0.000488281 6.40019C0.000488281 40.5336 0.000488281 74.666 0.000488281 108.799C0.000488281 113.067 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86559 127.999 6.40068 127.999C7.90548 127.999 9.41031 127.999 10.9151 127.999C13.5302 127.999 16.1457 127.999 18.7602 127.999C19.0402 127.999 19.3202 127.999 19.6001 127.999V0H19.6007Z"
        fill="url(#paint1_linear_6150_22791)"
      />
      <path
        opacity="0.2"
        d="M332.399 0C332.679 0 332.959 0 333.239 0C334.556 0 335.872 0 337.189 0C337.238 0 337.288 0 337.338 0C337.372 0 337.406 0 337.44 0C338.655 0 339.87 0 341.085 0C342.59 0 344.095 0 345.599 0C349.134 0 351.999 2.86566 351.999 6.40019C351.999 40.5336 351.999 74.666 351.999 108.799C351.999 113.067 351.999 117.333 351.999 121.6C351.999 125.134 349.134 127.999 345.599 127.999C344.095 127.999 342.59 127.999 341.085 127.999C338.47 127.999 335.854 127.999 333.239 127.999C332.959 127.999 332.68 127.999 332.4 127.999V0H332.399Z"
        fill="url(#paint2_linear_6150_22791)"
      />
      <path
        d="M19.8565 19.5997C19.6759 19.5997 19.6008 19.6747 19.6008 19.8565C19.6008 49.2859 19.6008 78.7147 19.6008 108.144C19.6008 108.325 19.6759 108.4 19.8565 108.4C49.2859 108.4 78.7148 108.4 108.144 108.4C108.326 108.4 108.4 108.325 108.4 108.144C108.4 78.7147 108.4 49.2859 108.4 19.8565C108.4 19.6747 108.326 19.5997 108.144 19.5997C78.7148 19.5997 49.2859 19.5997 19.8565 19.5997Z"
        fill="#575756"
      />
      <path
        d="M107.745 20.2555V19.9998H20.2573"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.745 19.9998C107.925 19.9998 108 20.0749 108 20.2555C108 49.4191 108 78.581 108 107.744C108 107.925 107.925 108 107.745 108C78.5818 108 49.4193 108 20.2569 108C20.0763 108 20.0012 107.925 20.0012 107.744C20.0012 78.5815 20.0012 49.4191 20.0012 20.2555C20.0012 20.0749 20.0763 19.9998 20.2569 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M108.001 107.744C108.001 107.925 107.926 108 107.745 108C78.5825 108 49.4199 108 20.2574 108C20.0768 108 20.0017 107.925 20.0017 107.744C20.0017 78.5813 20.0017 49.4187 20.0017 20.2556C20.0017 20.075 20.0768 19.9999 20.2574 19.9999C49.4199 19.9999 78.5825 19.9999 107.745 19.9999C107.926 19.9999 108.001 20.075 108.001 20.2556C108.001 49.4187 108.001 78.5813 108.001 107.744Z"
        fill="#E3E3E3"
      />
      <path
        d="M19.8549 108.4C19.6743 108.4 19.5993 108.325 19.5993 108.145C19.5993 78.7153 19.5993 49.286 19.5993 19.8566C19.5993 19.676 19.6743 19.6008 19.8549 19.6008C49.2843 19.6008 78.7131 19.6008 108.143 19.6008C108.323 19.6008 108.398 19.676 108.398 19.8566C108.398 49.286 108.398 78.7153 108.398 108.145C108.398 108.325 108.323 108.4 108.143 108.4C78.7131 108.4 49.2843 108.4 19.8549 108.4Z"
        fill="#575756"
      />
      <path
        d="M19.9995 20.2567C19.9995 49.4191 19.9995 78.5821 19.9995 107.744C19.9995 107.925 20.0746 108 20.2552 108C49.4176 108 78.58 108 107.742 108C107.923 108 107.998 107.925 107.998 107.744C107.998 78.5821 107.998 49.4191 107.998 20.2567C107.998 20.0761 107.923 20.001 107.742 20.001C78.58 20.001 49.4176 20.001 20.2552 20.001C20.0746 20.0004 19.9995 20.0756 19.9995 20.2567Z"
        fill="#E3E3E3"
      />
      <path
        d="M60.9423 75.1203C61.1229 75.1203 61.198 75.0452 61.198 74.8646C61.198 67.6217 61.198 60.3794 61.198 53.1365C61.198 52.9559 61.1229 52.8807 60.9423 52.8807C51.8497 52.8807 42.7555 52.8807 33.6629 52.8807C33.4823 52.8807 33.4072 52.9559 33.4072 53.1365C33.4072 60.3794 33.4072 67.6217 33.4072 74.8646C33.4072 75.0452 33.4823 75.1203 33.6629 75.1203C42.7555 75.1203 51.8497 75.1203 60.9423 75.1203Z"
        fill="#575756"
      />
      <path
        d="M34.063 74.7202C33.8813 74.7202 33.8061 74.645 33.8061 74.4644C33.8061 67.4885 33.8061 60.5121 33.8061 53.5367C33.8061 53.3555 33.8813 53.2804 34.063 53.2804C42.8892 53.2804 51.7159 53.2804 60.542 53.2804C60.7238 53.2804 60.7988 53.3555 60.7988 53.5367C60.7988 60.5121 60.7988 67.4885 60.7988 74.4644C60.7988 74.645 60.7238 74.7202 60.542 74.7202C51.7159 74.7202 42.8892 74.7202 34.063 74.7202Z"
        fill="#E3E3E3"
      />
      <path
        d="M36.5893 89.8122C36.5893 90.152 36.4494 90.293 36.1096 90.293C35.8956 90.293 35.6828 90.293 35.47 90.293C35.47 91.156 35.47 92.0208 35.47 92.8838C37.3496 92.8838 39.2304 92.8838 41.11 92.8838C41.4498 92.8838 41.5908 93.025 41.5908 93.3648C41.5908 93.7046 41.4498 93.8445 41.11 93.8445C40.4417 93.8445 39.7728 93.8445 39.1033 93.8445C39.1033 94.7075 39.1033 95.5723 39.1033 96.4353C39.3161 96.4353 39.529 96.4353 39.7429 96.4353C40.0827 96.4353 40.2226 96.5753 40.2226 96.9151C40.2226 97.2448 40.2226 97.5744 40.2226 97.904C40.2226 98.2438 40.0827 98.3849 39.7429 98.3849C38.9967 98.3849 38.2499 98.3849 37.5037 98.3849C37.1639 98.3849 37.024 98.2438 37.024 97.904C37.024 97.5744 37.024 97.2448 37.024 96.9151C37.024 96.5753 37.1639 96.4353 37.5037 96.4353C37.7165 96.4353 37.9305 96.4353 38.1433 96.4353C38.1433 95.5723 38.1433 94.7075 38.1433 93.8445C36.0407 93.8445 33.9387 93.8445 31.8362 93.8445C31.8362 94.7075 31.8362 95.5723 31.8362 96.4353C32.049 96.4353 32.2618 96.4353 32.4757 96.4353C32.8155 96.4353 32.9555 96.5753 32.9555 96.9151C32.9555 97.2448 32.9555 97.5744 32.9555 97.904C32.9555 98.2438 32.8155 98.3849 32.4757 98.3849C31.7295 98.3849 30.9827 98.3849 30.2366 98.3849C29.8968 98.3849 29.7568 98.2438 29.7568 97.904C29.7568 97.5744 29.7568 97.2448 29.7568 96.9151C29.7568 96.5753 29.8968 96.4353 30.2366 96.4353C30.4493 96.4353 30.6633 96.4353 30.8761 96.4353C30.8761 95.5723 30.8761 94.7075 30.8761 93.8445C30.2067 93.8445 29.5378 93.8445 28.8684 93.8445C28.5286 93.8445 28.3886 93.7046 28.3886 93.3648C28.3886 93.025 28.5286 92.8838 28.8684 92.8838C30.7491 92.8838 32.6287 92.8838 34.5094 92.8838C34.5094 92.0208 34.5094 91.156 34.5094 90.293C34.2966 90.293 34.0827 90.293 33.8699 90.293C33.5301 90.293 33.3901 90.152 33.3901 89.8122C33.3901 89.4826 33.3901 89.1528 33.3901 88.8232C33.3901 88.4834 33.5301 88.3435 33.8699 88.3435C34.6161 88.3435 35.3628 88.3435 36.109 88.3435C36.4488 88.3435 36.5888 88.4834 36.5888 88.8232C36.5893 89.1528 36.5893 89.4826 36.5893 89.8122Z"
        fill="#575756"
      />
      <path
        d="M37.702 59.5203V70.5607H56.9031V59.5203H52.5021V57.1202H50.9025V55.2001H43.7025V57.1202H42.1029V59.5203H37.702Z"
        fill="#3C3C3B"
      />
      <path
        d="M36.9823 55.2802H41.3025V57.3596H36.9823V55.2802Z"
        fill="#C6C6C6"
      />
      <path
        d="M53.3025 55.2802H57.6228V57.3596H53.3025V55.2802Z"
        fill="#C6C6C6"
      />
      <path d="M53.3025 70.5608V68.4803H52.5382V70.5608" fill="#CA9E67" />
      <path d="M51.5793 70.5608V68.4803H50.9336V70.5608" fill="#CA9E67" />
      <path d="M49.9729 70.5608V68.4803H49.3272V70.5608" fill="#CA9E67" />
      <path d="M48.3672 70.5608V68.4803H47.721V70.5608" fill="#CA9E67" />
      <path d="M46.7605 70.5608V68.4803H46.1142V70.5608" fill="#CA9E67" />
      <path d="M45.1543 70.5608V68.4803H44.5086V70.5608" fill="#CA9E67" />
      <path d="M43.5483 70.5608V68.4803H42.902V70.5608" fill="#CA9E67" />
      <path d="M41.9421 70.5608V68.4803H41.3026V70.5608" fill="#CA9E67" />
      <path
        d="M97.6827 99.2512C98.2666 99.2512 98.7399 98.7779 98.7399 98.194C98.7399 97.6101 98.2666 97.1368 97.6827 97.1368C97.0988 97.1368 96.6255 97.6101 96.6255 98.194C96.6255 98.7779 97.0988 99.2512 97.6827 99.2512Z"
        fill="#575756"
      />
      <path
        d="M97.3583 95.5366C97.7359 95.5366 97.9657 95.1212 97.7647 94.8006C97.5034 94.3852 97.176 94.5618 96.8221 94.6199C96.0974 94.739 95.5504 95.0236 95.0317 95.5417C94.5124 96.061 94.2291 96.6079 94.1094 97.3321C94.0513 97.686 93.874 98.0145 94.2906 98.2759C94.6101 98.4763 95.0261 98.2471 95.0261 97.8689C95.0272 96.5809 96.0714 95.5383 97.3583 95.5366Z"
        fill="#575756"
      />
      <path
        d="M97.3581 92.9768C97.9982 92.9768 97.9807 92.015 97.34 92.0173C96.8247 92.0184 96.3302 92.0839 95.8318 92.2188C94.7966 92.4982 93.981 92.974 93.2224 93.7315C92.4644 94.4901 91.988 95.3058 91.7074 96.341C91.5725 96.8399 91.5071 97.335 91.5054 97.8514C91.5037 98.4915 92.4655 98.5096 92.4655 97.8689C92.4655 95.1709 94.6606 92.9768 97.3581 92.9768Z"
        fill="#575756"
      />
      <path
        d="M97.3582 90.4166C97.7138 90.4166 97.8583 90.2641 97.8374 89.9097C97.8007 89.2577 97.2764 89.4457 96.8384 89.4728C96.1548 89.5146 95.5012 89.6342 94.8476 89.8391C93.4963 90.2624 92.4131 90.9228 91.4129 91.923C90.4127 92.9232 89.7523 94.0058 89.329 95.3577C89.1241 96.0101 89.0039 96.6644 88.9621 97.3473C88.935 97.7859 88.7459 98.3109 89.3984 98.3481C89.7535 98.3679 89.9059 98.2245 89.9059 97.8683C89.9059 93.7591 93.2491 90.4166 97.3582 90.4166Z"
        fill="#575756"
      />
      <path
        d="M131.856 19.5996C131.675 19.5996 131.6 19.6747 131.6 19.8564C131.6 49.2858 131.6 78.7146 131.6 108.144C131.6 108.325 131.675 108.4 131.856 108.4C161.285 108.4 190.714 108.4 220.143 108.4C220.325 108.4 220.4 108.325 220.4 108.144C220.4 78.7146 220.4 49.2858 220.4 19.8564C220.4 19.6747 220.325 19.5996 220.143 19.5996C190.714 19.5996 161.285 19.5996 131.856 19.5996Z"
        fill="#575756"
      />
      <path
        d="M219.744 20.2555V19.9998H132.257"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.744 19.9998C219.924 19.9998 219.999 20.0749 219.999 20.2555C219.999 49.419 219.999 78.5809 219.999 107.744C219.999 107.924 219.924 108 219.744 108C190.581 108 161.418 108 132.256 108C132.075 108 132 107.924 132 107.744C132 78.5815 132 49.419 132 20.2555C132 20.0749 132.075 19.9998 132.256 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M176 94.8792C193.054 94.8792 206.879 81.0539 206.879 63.9997C206.879 46.9454 193.054 33.1202 176 33.1202C158.945 33.1202 145.12 46.9454 145.12 63.9997C145.12 81.0539 158.945 94.8792 176 94.8792Z"
        fill="url(#paint3_linear_6150_22791)"
      />
      <path
        d="M160.64 68.5598C163.158 68.5598 165.2 66.5182 165.2 63.9997C165.2 61.4812 163.158 59.4396 160.64 59.4396C158.121 59.4396 156.08 61.4812 156.08 63.9997C156.08 66.5182 158.121 68.5598 160.64 68.5598Z"
        fill="#3C3C3B"
      />
      <path
        d="M191.36 68.5599C193.878 68.5599 195.92 66.5182 195.92 63.9997C195.92 61.4813 193.878 59.4396 191.36 59.4396C188.841 59.4396 186.8 61.4813 186.8 63.9997C186.8 66.5182 188.841 68.5599 191.36 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M208.668 98.0225C208.256 98.4357 208.256 99.1051 208.668 99.5183C209.082 99.9326 209.75 99.9297 210.163 99.5171C210.577 99.1051 210.577 98.4357 210.164 98.0225C209.751 97.6105 209.081 97.6105 208.668 98.0225Z"
        fill="#575756"
      />
      <path
        d="M205.653 98.2906C204.921 98.2906 204.189 98.2906 203.457 98.2906C203.327 98.2906 203.275 98.2375 203.275 98.1088C203.275 96.3438 203.275 94.5788 203.275 92.8138C203.275 92.6845 203.328 92.632 203.457 92.632C205.222 92.632 206.987 92.632 208.752 92.632C208.88 92.632 208.933 92.6851 208.933 92.8138C208.933 93.5459 208.933 94.278 208.933 95.0112C208.933 95.351 209.074 95.491 209.413 95.491C209.753 95.491 209.894 95.351 209.894 95.0112C209.894 94.278 209.894 93.5459 209.894 92.8138C209.893 92.1833 209.382 91.6731 208.752 91.672C206.987 91.672 205.222 91.672 203.457 91.672C202.827 91.672 202.315 92.1833 202.315 92.8138C202.315 94.5788 202.315 96.3438 202.315 98.1088C202.315 98.7393 202.827 99.2507 203.457 99.2507C204.189 99.2507 204.921 99.2507 205.654 99.2507C205.992 99.2507 206.133 99.1108 206.133 98.771C206.133 98.4312 205.991 98.2906 205.653 98.2906Z"
        fill="#575756"
      />
      <path
        d="M179.12 41.5998V33.2873C178.088 33.1823 177.048 33.1197 175.999 33.1197C174.947 33.1197 173.906 33.1739 172.88 33.276V41.5993H179.12V41.5998Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.599 59.3103C149.599 55.5314 149.599 51.7519 149.599 47.9729C147.454 51.4996 146.003 55.4924 145.417 59.7602C146.661 59.7602 147.905 59.7602 149.15 59.7602C149.467 59.7602 149.599 59.6287 149.599 59.3103Z"
        fill="#D0D0D0"
      />
      <path
        d="M202.893 59.7602C204.124 59.7602 205.356 59.7602 206.587 59.7602C206.579 59.7071 206.572 59.6535 206.564 59.6004C206.556 59.5473 206.549 59.4938 206.541 59.4407C205.952 55.493 204.721 51.9749 202.72 48.521C202.618 48.3466 202.504 48.1801 202.4 48.0085C202.4 51.7609 202.4 55.515 202.4 59.2674C202.4 59.6157 202.544 59.7602 202.893 59.7602Z"
        fill="#D0D0D0"
      />
      <path
        d="M172.879 86.3995V94.7228C173.905 94.8255 174.946 94.8791 175.999 94.8791C177.052 94.8791 178.093 94.825 179.119 94.7228V86.3995H172.879Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.073 68.2397C147.855 68.2397 146.636 68.2397 145.417 68.2397C146.003 72.5081 147.454 76.4998 149.599 80.0264C149.599 76.2729 149.599 72.5199 149.599 68.7664C149.599 68.3938 149.445 68.2397 149.073 68.2397Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.012 68.2397C202.579 68.2397 202.4 68.4193 202.4 68.8505C202.4 72.5764 202.4 76.3016 202.4 80.0264C204.545 76.4998 205.996 72.5081 206.582 68.2397C205.392 68.2397 204.202 68.2397 203.012 68.2397Z"
        fill="#D0D0D0"
      />
      <path
        d="M174.102 94.8091C174.732 94.8498 175.364 94.8797 175.999 94.8797C176.637 94.8797 177.268 94.8532 177.896 94.8148V85.2712H174.102V94.8091H174.102Z"
        fill="url(#paint4_linear_6150_22791)"
      />
      <path
        d="M177.896 33.1902C177.267 33.1496 176.635 33.1197 175.999 33.1197C175.362 33.1197 174.731 33.1462 174.103 33.1846V42.7281H177.897V33.1902H177.896Z"
        fill="url(#paint5_linear_6150_22791)"
      />
      <path
        d="M244.256 19.5996C244.075 19.5996 244 19.6747 244 19.8564C244 49.2858 244 78.7146 244 108.144C244 108.325 244.075 108.4 244.256 108.4C273.685 108.4 303.114 108.4 332.543 108.4C332.725 108.4 332.8 108.325 332.8 108.144C332.8 78.7146 332.8 49.2858 332.8 19.8564C332.8 19.6747 332.725 19.5996 332.543 19.5996C303.114 19.5996 273.685 19.5996 244.256 19.5996Z"
        fill="#575756"
      />
      <path
        d="M332.144 20.2555V19.9998H244.656"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M332.144 19.9998C332.324 19.9998 332.399 20.0749 332.399 20.2555C332.399 49.419 332.399 78.5809 332.399 107.744C332.399 107.924 332.324 108 332.144 108C302.981 108 273.818 108 244.656 108C244.475 108 244.4 107.924 244.4 107.744C244.4 78.5815 244.4 49.419 244.4 20.2555C244.4 20.0749 244.475 19.9998 244.656 19.9998"
        fill="#E3E3E3"
      />
      <path
        d="M288.399 94.8792C305.454 94.8792 319.279 81.0539 319.279 63.9997C319.279 46.9454 305.454 33.1202 288.399 33.1202C271.345 33.1202 257.52 46.9454 257.52 63.9997C257.52 81.0539 271.345 94.8792 288.399 94.8792Z"
        fill="url(#paint6_linear_6150_22791)"
      />
      <path
        d="M273.04 68.5598C275.558 68.5598 277.6 66.5182 277.6 63.9997C277.6 61.4812 275.558 59.4396 273.04 59.4396C270.521 59.4396 268.48 61.4812 268.48 63.9997C268.48 66.5182 270.521 68.5598 273.04 68.5598Z"
        fill="#3C3C3B"
      />
      <path
        d="M303.76 68.5599C306.278 68.5599 308.32 66.5182 308.32 63.9997C308.32 61.4813 306.278 59.4396 303.76 59.4396C301.241 59.4396 299.199 61.4813 299.199 63.9997C299.199 66.5182 301.241 68.5599 303.76 68.5599Z"
        fill="#3C3C3B"
      />
      <path
        d="M321.068 98.0225C320.656 98.4357 320.656 99.1051 321.068 99.5183C321.482 99.9326 322.15 99.9297 322.563 99.5171C322.976 99.1051 322.977 98.4357 322.564 98.0225C322.151 97.6105 321.481 97.6105 321.068 98.0225Z"
        fill="#575756"
      />
      <path
        d="M318.053 98.2906C317.321 98.2906 316.589 98.2906 315.857 98.2906C315.727 98.2906 315.675 98.2375 315.675 98.1088C315.675 96.3438 315.675 94.5788 315.675 92.8138C315.675 92.6845 315.728 92.632 315.857 92.632C317.622 92.632 319.387 92.632 321.152 92.632C321.28 92.632 321.333 92.6851 321.333 92.8138C321.333 93.5459 321.333 94.278 321.333 95.0112C321.333 95.351 321.473 95.491 321.813 95.491C322.153 95.491 322.294 95.351 322.294 95.0112C322.294 94.278 322.294 93.5459 322.294 92.8138C322.293 92.1833 321.782 91.6731 321.152 91.672C319.387 91.672 317.622 91.672 315.857 91.672C315.227 91.672 314.715 92.1833 314.715 92.8138C314.715 94.5788 314.715 96.3438 314.715 98.1088C314.715 98.7393 315.227 99.2507 315.857 99.2507C316.589 99.2507 317.321 99.2507 318.053 99.2507C318.392 99.2507 318.533 99.1108 318.533 98.771C318.533 98.4312 318.391 98.2906 318.053 98.2906Z"
        fill="#575756"
      />
      <path
        d="M291.519 41.5998V33.2873C290.488 33.1823 289.447 33.1197 288.399 33.1197C287.347 33.1197 286.306 33.1739 285.28 33.276V41.5993H291.519V41.5998Z"
        fill="#3C3C3B"
      />
      <path
        d="M261.999 59.3103C261.999 55.5314 261.999 51.7519 261.999 47.9729C259.854 51.4996 258.403 55.4924 257.817 59.7602C259.061 59.7602 260.305 59.7602 261.549 59.7602C261.867 59.7602 261.999 59.6287 261.999 59.3103Z"
        fill="#D0D0D0"
      />
      <path
        d="M315.293 59.7602C316.524 59.7602 317.756 59.7602 318.987 59.7602C318.979 59.7071 318.972 59.6535 318.964 59.6004C318.956 59.5473 318.949 59.4938 318.941 59.4407C318.352 55.493 317.121 51.9749 315.12 48.521C315.018 48.3466 314.903 48.1801 314.8 48.0085C314.8 51.7609 314.8 55.515 314.8 59.2674C314.8 59.6157 314.944 59.7602 315.293 59.7602Z"
        fill="#D0D0D0"
      />
      <path
        d="M285.279 86.3995V94.7228C286.305 94.8255 287.346 94.8791 288.399 94.8791C289.452 94.8791 290.493 94.825 291.519 94.7228V86.3995H285.279Z"
        fill="#3C3C3B"
      />
      <path
        d="M261.473 68.2397C260.255 68.2397 259.036 68.2397 257.817 68.2397C258.403 72.5081 259.854 76.4998 261.999 80.0264C261.999 76.2729 261.999 72.5199 261.999 68.7664C261.999 68.3938 261.845 68.2397 261.473 68.2397Z"
        fill="#D0D0D0"
      />
      <path
        d="M315.411 68.2397C314.978 68.2397 314.8 68.4193 314.8 68.8505C314.8 72.5764 314.8 76.3016 314.8 80.0264C316.945 76.4998 318.396 72.5081 318.982 68.2397C317.792 68.2397 316.602 68.2397 315.411 68.2397Z"
        fill="#D0D0D0"
      />
      <path
        d="M286.502 94.8091C287.132 94.8498 287.764 94.8797 288.399 94.8797C289.037 94.8797 289.668 94.8532 290.296 94.8148V85.2712H286.502V94.8091H286.502Z"
        fill="url(#paint7_linear_6150_22791)"
      />
      <path
        d="M290.296 33.1902C289.666 33.1496 289.035 33.1197 288.399 33.1197C287.761 33.1197 287.131 33.1462 286.503 33.1846V42.7281H290.297V33.1902H290.296Z"
        fill="url(#paint8_linear_6150_22791)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6150_22791"
          x1="176"
          y1="109.076"
          x2="176"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6150_22791"
          x1="16.5595"
          y1="63.9993"
          x2="0.308842"
          y2="63.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6150_22791"
          x1="335.441"
          y1="63.9996"
          x2="351.691"
          y2="63.9996"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6150_22791"
          x1="176"
          y1="94.8796"
          x2="176"
          y2="33.1196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6150_22791"
          x1="176"
          y1="94.7473"
          x2="176"
          y2="85.2422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6150_22791"
          x1="175.999"
          y1="33.2522"
          x2="175.999"
          y2="42.7572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6150_22791"
          x1="288.399"
          y1="94.8796"
          x2="288.399"
          y2="33.1196"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6150_22791"
          x1="288.4"
          y1="94.7473"
          x2="288.4"
          y2="85.2422"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6150_22791"
          x1="288.399"
          y1="33.2522"
          x2="288.399"
          y2="42.7572"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
